<div class="search-panel-header">
  <span class="current-county"
        [rlstTooltip]="currentCountyTooltip"
        tooltipPosition="below">
    {{currentCounty}}
  </span>
  <div class="change-county pl-2">
    <button type="button" class="btn-action-link" (click)="changeRegionClick()">
      <span class="icon-change-county">
        <i class="fa fa-map-marker" aria-hidden="true"></i> Change County
      </span>
    </button>
  </div>
  <div  class="toggle-wrapper-opened d-none d-md-block">
    <button type="button"
            class="toggle-wrapper-opened__btn"
            rlstTooltip="Collapse Search Bar"
            tooltipPosition="left"
            (click)="toggleSidePanel()">
      <i class="fa fa-angle-double-left" aria-hidden="true"></i>
      <span class="sr-only">Collapse search bar</span>
    </button>
  </div>
</div>
<div aria-label="tertiary navbar" class="tertiary-nav">
  <ul id="tertiaryNav" role="tablist" class="nav nav-tabs">
    <li class="nav-item" (click)="openTab(sidePanelTabState.quickSearch)">
      <span class="nav-link nav-link__first"
            [ngClass]="{'active': sidePanelTabOpened === sidePanelTabState.quickSearch}"
            data-toggle="tab"
            role="tab">
        QUICK SEARCH
      </span>
    </li>
    <li class="nav-item" (click)="openTab(sidePanelTabState.mySearch)">
      <span class="nav-link"
            [ngClass]="{'active': sidePanelTabOpened === sidePanelTabState.mySearch}"
            data-toggle="tab"
            role="tab">
        MY SEARCH
      </span>
    </li>
  </ul>
</div>
<div class="card h-100" [ngSwitch]="sidePanelTabOpened">
  <div class="card-body tab-content">
      <div class="tab-pane show active h-100" *ngSwitchCase="sidePanelTabState.quickSearch">
          <rlst-quick-search (clearSearchResults)="clearSearchResultsAction()">
            <rlst-grid-pagination
              class="js-grid-pagination"
              [searchResultsCount]="searchResultsCount"
              [totalGridRecords]="totalGridRecords"
              [currentGridPage]="currentGridPage"
              (changeGridPage)="changeGridPage.emit($event)">
            </rlst-grid-pagination>
          </rlst-quick-search>
      </div>
      <div class="tab-pane show active h-100" *ngSwitchCase="sidePanelTabState.mySearch">
        <ng-container *ngIf="{ isSelectedSearch: isSelectedSearch$ | async } as templateState">
          <div *ngIf="isLoginInProgress || !templateState.isSelectedSearch; else mySearchTemplate" aria-hidden="true">
            <rlst-spinner-circle panelClass="spinner-small" class="loading w-100"></rlst-spinner-circle>
          </div>

          <ng-template #mySearchTemplate>
            <rlst-my-search (clearSearchResults)="clearSearchResultsAction()">
              <rlst-grid-pagination
                class="js-grid-pagination"
                [searchResultsCount]="searchResultsCount"
                [totalGridRecords]="totalGridRecords"
                [currentGridPage]="currentGridPage"
                (changeGridPage)="changeGridPage.emit($event)">
              </rlst-grid-pagination>
            </rlst-my-search>
          </ng-template>
        </ng-container>
      </div>
      <!-- <div class="tab-pane show active h-100" *ngSwitchCase="sidePanelTabState.premiumSearch">
         <rlst-premium-search  (clearSearchResults)="clearSearchResultsAction()">
          <rlst-grid-pagination
            class="js-grid-pagination"
            [searchResultsCount]="searchResultsCount"
            [totalGridRecords]="totalGridRecords"
            [currentGridPage]="currentGridPage"
            (changeGridPage)="changeGridPage.emit($event)">
          </rlst-grid-pagination>
         </rlst-premium-search>
      </div> -->
  </div>
</div>
